<template>
  <div class="row">

    <div class="col-12">
      <Card :title="`Tambah Komisi Dokter Untuk ${data.name}`">
        <template v-slot:body>
          <Form
            :form="form"
            :doctors_id="doctors_id"
            redirect="/doctors/list"
          />
        </template>
      </Card>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/doctors/DoctorCommisionForm.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        payment_category_id: '',
        doctor_id: [],
        hospital_income: '',
        doctor_commission: '',
        price: 0
      },          
      // Detail Data
      data: {},      
      // Other
      doctors_id: [],
    }
  },

  methods: {    

    async getData() {
      this.data = await module.get('doctors/' + this.$route.params.id)
      // this.form.price = parseInt(this.data.price).toLocaleString('id-ID')
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push('/doctor/list')
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dokter", route: "" },
      { title: "Daftar Dokter", route: "/doctor/list" },
      { title: "Tambah Komisi Dokter" },
    ])
    this.getData()
  },

}
</script>